import { PricingTable } from '@clerk/clerk-react'
import { useSearchParams } from 'react-router-dom'
import { PageContainer } from '@/components/Container'

export default function Subscription() {
  const [searchParams] = useSearchParams()
  const returnTo = searchParams.get('returnTo')
  const gameReturn = searchParams.get('gameReturn')

  const safeReturnTo = returnTo && returnTo.startsWith('/') && !returnTo.startsWith('//')
    ? returnTo
    : null

  // Hub path to land on after subscribe (game page or /games fallback)
  const hubReturnPath = safeReturnTo ?? '/games'

  // Build redirect URL, then validate output origin — /\evil.com bypasses startsWith guards
  // but new URL() resolves it to https://evil.com/. Origin check catches that after resolution.
  const hubReturnUrl = new URL(hubReturnPath, window.location.origin)
  const safeHubReturnUrl = hubReturnUrl.origin === window.location.origin
    ? hubReturnUrl
    : new URL('/games', window.location.origin)
  if (gameReturn) safeHubReturnUrl.searchParams.set('iframeSrc', gameReturn)

  return (
    <PageContainer>
      <div className="space-y-6">
        {/* Page Header Section */}
        <section className="pb-2 pt-4 px-2">
          <h1 className="font-bebas-neue text-5xl tracking-[2px] uppercase text-foreground mb-2">
            Choose Your Plan
          </h1>
          <p className="font-oswald text-lg font-normal text-muted-foreground">
            Unlock premium features and archive access
          </p>
        </section>

        {/* Pricing Table Section */}
        <section className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-sm">
          <div className="max-w-4xl mx-auto">
            <PricingTable
              newSubscriptionRedirectUrl={safeHubReturnUrl.toString()}
              appearance={{
                elements: {
                  pricingTableCardPeriodToggle: { display: 'none' },
                  pricingTableCardStatus: {
                    backgroundColor: 'transparent',
                    border: '2px solid currentColor',
                    color: 'inherit',
                    fontWeight: '600',
                    fontSize: '14px',
                    padding: '4px 12px',
                  },
                  pricingTableCardTitle: {
                    fontFamily: '"Bebas Neue", sans-serif !important',
                    fontSize: '22px !important',
                    letterSpacing: '1px !important',
                    textTransform: 'uppercase !important',
                  },
                  pricingTableCardFee: {
                    fontFamily: '"Bebas Neue", sans-serif !important',
                    fontSize: '40px !important',
                    letterSpacing: '1px !important',
                  },
                  pricingTableCardFooterButton: {
                    backgroundColor: '#FFA504 !important',
                    color: '#1a1a1a !important',
                    fontFamily: '"Oswald", sans-serif !important',
                    fontWeight: '600 !important',
                    fontSize: '15px !important',
                    letterSpacing: '0.5px !important',
                    textTransform: 'uppercase !important',
                    borderRadius: '8px !important',
                  },
                },
              }}
            />
          </div>
        </section>
      </div>
    </PageContainer>
  )
}
